import React, { useState } from 'react';
import c from 'classnames';
import AnimateHeight from 'react-animate-height';
import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

export interface AccordionProps extends
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  title: string;
  label?: string;
  initialCollapsed?: boolean;
}

const AccordionItem: React.FC<AccordionProps> = ({
  title,
  label,
  initialCollapsed = true,
  className,
  children,
  ...props
}) => {
  const [collapsed, setCollapsed] = useState(initialCollapsed);

  return (
    <div className={c(className, 'AccordionItem', { collapsed })} {...props}>
      <h3 className="AccordionItem__control">
        <button type="button" onClick={() => setCollapsed(!collapsed)}>
          <div className="AccordionItem__control_content">
            {label && <p className="AccordionItem__label mb-0">{label}</p>}
            <p className="AccordionItem__title">{title}</p>
          </div>
          <Icon name={collapsed ? 'expand_more' : 'expand_less'} />
        </button>
      </h3>
      <AnimateHeight
        duration={300}
        height={collapsed ? 0 : 'auto'}
      >
        <div className="AccordionItem__content">
          {children}
        </div>
      </AnimateHeight>
    </div>
  );
};

export default AccordionItem;
